export const DATE_FORMAT = 'YYYY-MM-DD'



// WEBPACK FOOTER //
// ./src/constants/dates.js